<div nz-row nzType="flex">
  <div nz-col nzXs="24" nzSm="24" nzMd="20" nzLg="20" nzXl="12">
    <div class="formname">{{ formTitle }}</div>
  </div>
  <div
    nz-col
    nzXs="24"
    nzSm="24"
    nzMd="4"
    nzLg="6"
    nzXl="12"
    style="display: flex; justify-content: flex-end"
  >
    <form nz-form [nzLayout]="'inline'">
      <nz-form-item>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input
            type="text"
            autocomplete="off"
            name="search"
            nz-input
            placeholder="Search Records"
            [(ngModel)]="searchText"
          />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button nz-button nzType="primary" (click)="search()" nzSearch>
            <i nz-icon nzType="search"></i>
          </button>
        </ng-template>
      </nz-form-item>
      <nz-form-item>
        <button nz-button nzType="primary" (click)="add()" nzJustify="end">
          <i nz-icon nzType="plus"></i>New User
        </button>
      </nz-form-item>
    </form>
  </div>
</div>

<div nz-row>
  <div nz-col nzSpan="24">
    <nz-table
      class="my-scroll no-wrap1"
      nzBordered
      #table
      nzShowSizeChanger
      [nzFrontPagination]="false"
      [nzData]="dataList"
      [nzLoading]="loadingRecords"
      [nzTotal]="totalRecords"
      [(nzPageIndex)]="pageIndex"
      [(nzPageSize)]="pageSize"
      (nzQueryParams)="sort($event)"
    >
      <thead>
        <tr>
          <th style="text-align: center">Edit</th>

          <th nzWidth="100px" style="text-align: center" nzLeft>Mapping</th>

          <th
            *ngFor="let column of columns"
            nzColumnKey="{{ column[0] }}"
            [nzSortFn]="true"
          >
            {{ column[1] }}
          </th>
          <th
            style="text-align: center"
            nzColumnKey="IS_ACTIVE"
            [nzSortFn]="true"
          >
            Active
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of table.data">
          <td style="text-align: center">
            <a (click)="edit(data)"
              ><i nz-icon nzType="edit" nzTheme="outline"></i
            ></a>
          </td>

          <td align="center" nzLeft>
            <nz-tag
              style="
                font-size: 14px;
                border-radius: 5px;
                margin-left: 12px;
                cursor: pointer;
              "
              [nzColor]="'blue'"
              (click)="mapAuthority(data)"
            >
              <i nz-icon nzType="form"></i>
              <!-- <span>Qualifications</span> -->
            </nz-tag>
          </td>
<td *ngFor="let column of columns"  [style.text-align]="column[0] === 'EMPLOYEE_ID' ? 'center' : 'left'">
  <span
    nz-tooltip
    [nzTooltipTitle]="data[column[0]]"
  >
    {{
      data[column[0]]?.length > 16
        ? (data[column[0]] | slice:0:16) + '...'
        : data[column[0]]
    }}
  </span>
</td>          <td style="text-align: center">
            <i
              nz-icon
              *ngIf="data.IS_ACTIVE"
              [nzType]="'check-circle'"
              [nzTheme]="'twotone'"
              [nzTwotoneColor]="'#52c41a'"
            ></i>
            <i
              nz-icon
              *ngIf="!data.IS_ACTIVE"
              [nzType]="'close-circle'"
              [nzTheme]="'twotone'"
              [nzTwotoneColor]="'#f50'"
            ></i>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<div *ngIf="drawerVisible">
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzClosable]="true"
    [nzMask]="true"
    [nzMaskClosable]="false"
    [nzWidth]="350"
    [nzVisible]="drawerVisible"
    [nzTitle]="drawerTitle"
    (nzOnClose)="drawerClose()"
    (nzKeyboard)="(true)"
  >
    <app-user [drawerClose]="closeCallback" [data]="drawerData"></app-user>
  </nz-drawer>
</div>

<!-- Mappings  -->

<div *ngIf="mapAuthorityDrawerVisible">
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'none',
      'padding-bottom': '53px'
    }"
    [nzClosable]="true"
    [nzMask]="true"
    [nzMaskClosable]="false"
    [nzWidth]="500"
    [nzVisible]="mapAuthorityDrawerVisible"
    [nzTitle]="mapAuthorityDrawerTitle"
    (nzOnClose)="mapQualificationsDrawerClose()"
    [nzFooter]="footer"
  >
    <div nz-row>
      <div nz-col nzSpan="24">
        <nz-table
          #table
          class="my-scroll no-wrap1"
          nzBordered
          [nzSize]="'small'"
          [nzData]="mapAuthoritySelectedItems"
          [nzLoading]="qualificationLoadingRecords"
          [nzFrontPagination]="false"
          [nzScroll]="''"
        >
          <thead>
            <tr>
              <th
                nzLeft
                [nzChecked]="checkedQualifications"
                [nzIndeterminate]="AuthorityIndeterminate"
                (nzCheckedChange)="onAllQualificationsChecked($event)"
                style="text-align: center; font-weight: bold"
              ></th>
              <th style="width: 970px; text-align: left; font-weight: bold">
                User Name
              </th>
              <!-- <th  style="text-align: left; font-weight: 500;"  >Role Name</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of mapAuthoritySelectedItems">
              <td
                nzLeft
                style="white-space: pre-line; text-align: center"
                [nzChecked]="mapAuthoritySetOfCheckedId.has(data.USER_ID)"
                (nzCheckedChange)="
                  onQualificationItemChecked(data.USER_ID, $event)
                "
              ></td>
              <td style="white-space: pre-line; text-align: left">
                {{ data.USER_NAME }}
                <span *ngIf="data.ROLE_NAME"> - ({{ data.ROLE_NAME }})</span>
              </td>
              <!-- <td   style="white-space: pre-line; text-align: left;">{{ data.ROLE_NAME }}</td> -->
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>

    <!-- Footer -->
    <ng-template #footer>
      <div style="display: flex; justify-content: flex-end">
        <button
          type="button"
          nz-button
          (click)="mapQualificationsDrawerClose()"
          style="margin-right: 8px"
        >
          Cancel
        </button>
        <button
          type="button"
          class="ant-btn ant-btn-primary"
          nz-button
          (click)="saveQualifications()"
          [nzLoading]="qualificationLoadingRecords"
        >
          Map & Close
        </button>
      </div>
    </ng-template>
  </nz-drawer>
</div>
